import React from 'react'

const Step = ({color = null}: {color: string | null}) => {
  return (
    <div className={`h-[8px] mr-3 w-[60px] rounded-full ${color || 'bg-gray-400'}`}></div>
  )
}

export default Step